import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import Week from 'routes/Products/components/Week';
import {page} from '../../../../../../lib/track';

class WeekPage extends PureComponent {
  componentDidMount() {
    page('weekly guide');
  }
  constructor(props) {
    super(props);
  }

  render() {
    return <Week {...this.props} />;
  }
}

WeekPage.propTypes = {
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  Children: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  data: PropTypes.shape({}).isRequired
};

export default WeekPage;
